import React from 'react'
import WithHeader from '../components/WithHeader'
import { View } from 'react-native'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { ListItemLinkButton } from '../components/ListItemLinkButton'
import { Dropdown } from '../components/dropdowns/Dropdown'
import { SensitiveActionsPanel } from '../components/SensitiveActionsPanel'
import { useTenantOrGlobalAdmin } from '../hooks/useTenantOrGlobalAdmin'
import {
  usePermissionsV2Checker,
  useV1Permission
} from '../hooks/usePermissionsV2Checker'

export default function SettingsIndexScreen({ navigation }) {
  const current_user = useSelector((state) => {
    return _.get(state, 'users.user')
  })

  const permissions = usePermissionsV2Checker()
  const canModifyEntityTypes = useV1Permission
    ? _.get(
        current_user,
        `effective_permissions['modify||name:entity types']`,
        false
      )
    : permissions.hasPermission(
        permissions.update,
        null,
        permissions.systemPermissions.entityTypes
      )

  const { isGlobalAdmin } = useTenantOrGlobalAdmin()

  const pageTitle = 'Admin Tools'
  return (
    <WithHeader
      title={pageTitle}
      navigation={navigation}
      leftButtonType={'back'}
    >
      <View key="view-module-wrapper">
        <View>
          {canModifyEntityTypes && (
            <ListItemLinkButton
              title={'Manage Entity Types'}
              to={`/settings/admin-tools/manage-entity-types/index`}
            />
          )}
          <ListItemLinkButton
            title={'Admin Modules'}
            to={`/settings/admin-tools/modules`}
          />
          {!!isGlobalAdmin && (
            <ListItemLinkButton
              title={'Manage Logins'}
              to={`/settings/manage-logins`}
            />
          )}
          {!!isGlobalAdmin && (
            <ListItemLinkButton
              title={'Manage Permissions'}
              to={`/settings/manage-permissions`}
            />
          )}
          <Dropdown
            positionAtButton={false}
            component={({ onPress }) => (
              <ListItemLinkButton
                title={'Sensitive Actions'}
                onPress={onPress}
              />
            )}
          >
            <SensitiveActionsPanel />
          </Dropdown>
        </View>
      </View>
    </WithHeader>
  )
}
